import { FaEnvelope, FaGithub, FaLinkedin } from "react-icons/fa";

export const footerItems = [
  {
    label: "GitHub",
    path: "https://github.com/dangol-anish",
    icon: FaGithub,
  },
  {
    label: "LinkedIn",
    path: "https://www.linkedin.com/in/dangol-anish",
    icon: FaLinkedin,
  },

  {
    label: "Email",
    path: "mailto:anishdangol.work@gmail.com",
    icon: FaEnvelope,
  },
];
